var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEurope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.563l.45 1.38h1.446l-1.176.85.45 1.387-1.175-.856-1.176.856.45-1.386-1.175-.85h1.451L12 3.562zM6.032 6.031l1.3.66 1.023-1.028-.227 1.435 1.294.66-1.435.228-.227 1.435-.661-1.3-1.435.233 1.029-1.029-.661-1.294zM3.562 12l1.381-.45v-1.446l.85 1.176 1.387-.45-.856 1.175.856 1.176-1.386-.45-.85 1.175v-1.451L3.562 12zm2.47 5.968l.66-1.3-1.028-1.023 1.435.227.66-1.294.228 1.435 1.435.227-1.3.661.233 1.435-1.029-1.029-1.294.661zM12 20.438l-.45-1.381h-1.446l1.176-.85-.45-1.387 1.175.855 1.176-.855-.45 1.386 1.175.85h-1.451L12 20.438zm5.968-2.47l-1.3-.66-1.023 1.028.227-1.435-1.294-.66 1.435-.228.227-1.435.661 1.3 1.435-.233-1.029 1.029.661 1.294zM20.438 12l-1.381.45v1.446l-.85-1.176-1.387.45.855-1.175-.855-1.176 1.386.45.85-1.175v1.451l1.381.455zm-2.47-5.968l-.66 1.3 1.028 1.023-1.435-.227-.66 1.294-.228-1.435-1.435-.227 1.3-.661-.233-1.435 1.029 1.029 1.294-.661z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.041 24a11.962 11.962 0 008.444-3.515c4.687-4.686 4.687-12.284 0-16.97l-16.97 16.97c.67.67 1.398 1.244 2.17 1.722l.948.53A12 12 0 0011.96 24h.082z",
    fill: "#EEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.742 21.93l-2.992-2.992v4.464c.273-.09.543-.189.81-.299l1.415-.693c.26-.15.516-.31.767-.48zM8.25 23.402v-4.464L5.258 21.93c.25.17.506.33.767.48l1.415.694c.267.109.537.209.81.298zM23.402 15.75a11.916 11.916 0 01-1.472 2.992l-2.992-2.992h4.464zM23.103 7.439c.11.267.21.538.299.811h-4.465l2.993-2.992c.17.251.331.508.48.768l.693 1.413z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75l-4.5 4.5v9.538c.73.139 1.469.21 2.209.212h.082c.74-.003 1.48-.073 2.209-.212V14.25h9.538a12.068 12.068 0 000-4.5H14.25z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.475 19.366L17.86 15.75H15.75l4.735 4.735c.358-.357.687-.73.99-1.12zM4.634 21.475L8.25 17.86V15.75l-4.735 4.735c.357.358.73.687 1.12.99z",
    fill: "#D80027"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "europe_svg__clip0_2003_27269"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurope);
export default __webpack_public_path__ + "static/media/europe.9033698b07d435f78d69bf26cc6e7b31.svg";
export { ForwardRef as ReactComponent };